import { history } from '../../store';
import _ from 'lodash';

export const cleanLocalStorage = () => localStorage.clear();

export const cleanLocalStorageByPrefix = prefix =>
    _.forIn(window.localStorage, (value: string, objKey: string) => {
        if (true === _.startsWith(objKey, prefix)) {
            window.localStorage.removeItem(objKey);
        }
    });

export const cleanSessionStorage = () => sessionStorage.clear();

export const redirectLogin = () => {
    cleanSessionStorage();
    cleanLocalStorage();
    history.push('/login');
};



// WEBPACK FOOTER //
// ./src/services/helper/auth-helper.js